import { publicAxios } from 'helpers/axios/axios';

const getRoom = async (roomName: string) =>
  await publicAxios
    .get(`/v1/studio/config?name=${roomName}`)
    .then((response) => response.data);

export default getRoom;
